var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticStyle: { width: "min-content" } }, [
    _c("div", { ref: "plot" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }